var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-button',{staticClass:"ant-btn-danger",attrs:{"type":"primary"},on:{"click":_vm.loginoutBtn}},[_vm._v(" "+_vm._s(_vm.$t('setting.btn_1'))),_c('a-icon',{attrs:{"type":"logout"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }